import moment from "moment";
import { createCrudActions } from '../utils/crudGenerator';

const formatIrregularitys = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
        date: item.date && moment(item.date),
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchIrregularitys,
    create: createIrregularity,
    update: updateIrregularity,
    delete: deleteIrregularitys
} = createCrudActions('IRREGULARITY', "Irregularidad", formatIrregularitys);
